import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "fixed inset-0 z-50 overflow-x-hidden vue-modal-background"
};
const _hoisted_2 = {
  class: "bg-gray-50 w-4/12 shadow-lg rounded-sm absolute top-44 right-1/4 p-6"
};
const _hoisted_3 = {
  class: ""
};
const _hoisted_4 = {
  class: "flex justify-center"
};
const _hoisted_5 = {
  class: "mr-20"
};
const _hoisted_6 = {
  class: "pt-2"
};
const _hoisted_7 = {
  class: "py-6"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  class: ""
};
const _hoisted_10 = {
  class: "row-fluid py-2"
};
const _hoisted_11 = {
  class: "w-full"
};
const _hoisted_12 = {
  class: "row-fluid py-2"
};
const _hoisted_13 = {
  class: "w-full"
};
const _hoisted_14 = {
  class: "row-fluid py-2"
};
const _hoisted_15 = {
  class: "w-full"
};
const _hoisted_16 = {
  class: "px-2 py-4 flex justify-between"
};
const _hoisted_17 = {
  class: "py-2"
};
const _hoisted_18 = {
  class: "py-2"
};
const _hoisted_19 = {
  class: "px-2 py-4 flex justify-between"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LlSwitch = _resolveComponent("LlSwitch");
  const _component_delete_custom_fields_modal = _resolveComponent("delete-custom-fields-modal");
  const _component_LlTooltip = _resolveComponent("LlTooltip");
  const _component_LlSelect = _resolveComponent("LlSelect");
  const _component_LlRadioGroup = _resolveComponent("LlRadioGroup");
  const _component_LlCheckbox = _resolveComponent("LlCheckbox");
  const _component_LlSecondaryButton = _resolveComponent("LlSecondaryButton");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("h3", _hoisted_5, _toDisplayString($setup.field.id ? "Edit Custom Field" : "Create New Field"), 1), _createElementVNode("div", _hoisted_6, [_createVNode(_component_LlSwitch, {
    modelValue: $setup.field.active,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.field.active = $event)
  }, null, 8, ["modelValue"])])]), _withDirectives(_createElementVNode("span", _hoisted_7, " Fields can be specific to clients or to matters. Once created, a custom field will be visible in the Info tab of either your clients or your matters, depending on which Field Visibility you select here. Custom fields must have a text value assigned to them in the Info tab to appear in invoices. ", 512), [[_vShow, !$setup.field.id]])]), $setup.customFieldStore.showDeleteCustomFieldsModal ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_delete_custom_fields_modal, {
    onClose: $setup.deleteCF
  }, null, 8, ["onClose"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("label", null, [_cache[10] || (_cache[10] = _createTextVNode("Field Value ", -1)), _createVNode(_component_LlTooltip, {
    icon: "help"
  }, {
    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode(" Field Value determines whether this field's contents are a value typed by you (Custom) or a variable retrieved by LeanLaw each time the field is used. ", -1)]))]),
    _: 1
  })]), _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.field.customFieldName = $event),
    disabled: true,
    class: "w-full h-10 px-3 border-gray-300 border rounded focus:outline-none focus:shadow-outline focus:ring focus:ring-[rgba(var(--v-theme-primary),0.3)]"
  }, null, 512), [[_vModelText, $setup.field.customFieldName]])])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("label", null, [_cache[12] || (_cache[12] = _createTextVNode("Field Name ", -1)), _createVNode(_component_LlTooltip, {
    icon: "help"
  }, {
    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" Name this field to identify it in the Info page of your clients or matters. The Field Name will be visible if the field is used in an invoice. ", -1)]))]),
    _: 1
  })]), _createElementVNode("div", null, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.field.name = $event),
    class: "w-full h-10 px-3 border-gray-300 border rounded focus:outline-none focus:shadow-outline focus:ring focus:ring-[rgba(var(--v-theme-primary),0.3)]"
  }, null, 512), [[_vModelText, $setup.field.name]])])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("label", null, [_cache[14] || (_cache[14] = _createTextVNode("Field Type ", -1)), _createVNode(_component_LlTooltip, {
    icon: "help"
  }, {
    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode(" Field Type determines the data format of the field. ", -1)]))]),
    _: 1
  })]), _createElementVNode("div", null, [_createVNode(_component_LlSelect, {
    modelValue: $setup.field.type,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $setup.field.type = $event),
    items: $setup.customFieldTypeOptions,
    "item-value": "value",
    "return-object": false,
    placeholder: "Select Field Type",
    disabled: true,
    clearable: false,
    "hide-details": true
  }, null, 8, ["modelValue", "items"])])])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_17, [_cache[16] || (_cache[16] = _createTextVNode(" Field Visibility ", -1)), _createVNode(_component_LlTooltip, {
    icon: "help"
  }, {
    default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode(" Field Visibility determines whether the field is assigned at the client level or applied to matters individually. ", -1)]))]),
    _: 1
  })]), _createVNode(_component_LlRadioGroup, {
    modelValue: $setup.field.entity,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $setup.field.entity = $event),
    options: $setup.customFieldClientMatterOptions,
    disabled: !!$setup.field.id
  }, null, 8, ["modelValue", "options", "disabled"])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_18, [_cache[18] || (_cache[18] = _createTextVNode(" Invoice Presentation ", -1)), _createVNode(_component_LlTooltip, {
    icon: "help"
  }, {
    default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" Invoice Presentation determines whether or not this field can appear on invoice memos. ", -1)]))]),
    _: 1
  })]), _createVNode(_component_LlCheckbox, {
    modelValue: $setup.field.showOnInvoice,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.field.showOnInvoice = $event),
    label: "Invoice Memo"
  }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_LlSecondaryButton, {
    onClick: _cache[6] || (_cache[6] = $event => $setup.close())
  }, {
    default: _withCtx(() => [...(_cache[19] || (_cache[19] = [_createTextVNode("Cancel", -1)]))]),
    _: 1
  }), _createElementVNode("div", null, [$setup.field.id ? (_openBlock(), _createBlock(_component_LlSecondaryButton, {
    key: 0,
    type: "button",
    color: "error",
    class: "mr-2",
    onClick: _cache[7] || (_cache[7] = $event => $setup.showDeleteModal())
  }, {
    default: _withCtx(() => [...(_cache[20] || (_cache[20] = [_createElementVNode("i", {
      class: "fa fa-trash mr-2"
    }, null, -1), _createTextVNode(" Delete ", -1)]))]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_LlSecondaryButton, {
    color: "primary",
    onClick: _cache[8] || (_cache[8] = $event => $setup.save())
  }, {
    default: _withCtx(() => [...(_cache[21] || (_cache[21] = [_createTextVNode("Save", -1)]))]),
    _: 1
  })])])])]);
}